import React from 'react';
import * as S from './BlockMobile.styles';

import IconSelector from '@ibibo/icon-selector';
import HeaderPartner from '../../../stories/components/Header/Header';

const BlockMobile = () => {
    return(
        <>
            <HeaderPartner userType="preregister" />
            <S.BlockMobileMainWrap>
                <S.BlockMobileInnerWrap>
                    <S.ImageWrap>
                        <IconSelector iconKey="mobileblock" />
                    </S.ImageWrap>
                    <S.HeadingWrap>    
                        <S.HeadingText>This section can only be <br />viewed on Desktop</S.HeadingText>
                    </S.HeadingWrap>
                    <S.SubHeadTextWrap>
                        <S.SubHeadText>Kindly login to your myPartner <br />account through desktop</S.SubHeadText>
                    </S.SubHeadTextWrap>
                </S.BlockMobileInnerWrap>
            </S.BlockMobileMainWrap>
        </>
    );
}

export default BlockMobile;